import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from '@/store';
import NProgress from 'nprogress';
import Home from '../views/Home.vue';
Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/document',
        name: 'Document',
        meta: { requireAuth: true },
        component: () => import('../views/Document.vue')
    },
    {
        path: '/member',
        name: 'Member',
        meta: { requireAuth: true },
        component: () => import('../views/Member.vue')
    },
    {
        path: '/download',
        name: 'Download',
        component: () => import('../views/Download.vue')
        // },
        // {
        //   path: '/forbidden',
        //   name: 'Forbidden',
        //   component: () => import('../views/Forbidden.vue')
        // },
        // {
        //   path: '/contact',
        //   name: 'Contact',
        //   component: () => import('../views/Contact.vue')
        // },
        // {
        //   path: '*', // 匹配所有未定義路由
        //   name: 'NotFound',
        //   redirect: { path: '/forbidden', query: { code: '404' } }
    }
];
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});
router.beforeEach(async (to, from, next) => {
    if (to.meta.requireAuth) {
        const { isLogin } = Store.state.auth;
        const { flag } = Store.state.auth.loginUser;
        if (isLogin) {
            if (flag === 2) {
                Store.commit('common/ChangeDialog', 'SetPassword');
            }
            else {
                next();
            }
        }
        else {
            if (!Store.state.message.snackbar.show && !Store.state.common.dialog.show) {
                Store.commit('common/ChangeDialog', 'Login');
                Store.dispatch('message/setSnackbar', {
                    show: true,
                    text: 'LOGINERROR_1',
                    timeout: 1200
                });
            }
            if (to.path !== '/') {
                return next({
                    path: '/',
                    query: { redirect: to.fullPath }
                });
            }
            else {
                return next(false);
            }
        }
    }
    else {
        next();
    }
    NProgress.start();
});
router.afterEach((to) => {
    NProgress.done();
});
export default router;
